import {
  startQa as startQaApi,
  stopQa as stopQaApi,
  promoteQa as promoteQaApi,
  removeQa as removeQaApi,
  moveUpQa as moveUpQaApi,
  moveTopQa as moveTopQaApi,
  qaList as qaListApi,
  qaFloorId as qaFloorIdApi,
  stopQaTalking as stopQaTalkingApi
} from "@/api/qa";

export function startQa() {
  return startQaApi().then(result => {
    return result;
  });
}

export function stopQa() {
  return stopQaApi().then(result => {
    return result;
  });
}

export function promoteQa(partyId) {
  return promoteQaApi(partyId);
}

export function stopQaTalking() {
  return stopQaTalkingApi().then(result => {
    return result;
  });
}

export function removeQa(partyId) {
  return removeQaApi(partyId);
}

export function moveUpQa(partyId) {
  return moveUpQaApi(partyId);
}

export function moveTopQa(partyId) {
  return moveTopQaApi(partyId);
}

export function qaList() {
  return qaListApi().then(result => {
    return result.data;
  });
}

export function qaFloorId() {
  return qaFloorIdApi().then(result => {
    return result.data;
  });
}
